import { render, staticRenderFns } from "./SupportDetail.vue?vue&type=template&id=66b2a62d&"
import script from "./SupportDetail.vue?vue&type=script&lang=js&"
export * from "./SupportDetail.vue?vue&type=script&lang=js&"
import style0 from "./SupportDetail.vue?vue&type=style&index=0&id=66b2a62d&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports